// extracted by mini-css-extract-plugin
export default {"section":"_2J1QU","subTitle":"_2S6Mp","channelDescription":"_3mPH3","descriptionContent":"_301_2","errorBox":"_2F-Hr","errorTitle":"_1XEaI","errorLink":"_3LLBs"};